export default "__VITE_ASSET__CSg0HykS__"